import type { AnalyticsObject, AnalyticsProperties } from '../types'

export interface CorridorParams {
  amount?: number
  amountUsd?: number
  defaultAmount?: number
  countryFrom: { iso: string }
  countryTo: { iso: string }
  currencyFrom: { iso: string }
  currencyTo: { iso: string }
  alternativeToNoResults?: string
}

export class Corridor implements AnalyticsObject {
  name: string
  properties: CorridorProperties
  constructor(properties: CorridorProperties) {
    this.name = 'Corridor'
    this.properties = properties
  }

  static getInstance(corridor: CorridorParams) {
    return new Corridor(mapCorridor(corridor))
  }
}

export interface CorridorProperties extends AnalyticsProperties {
  corridor: {
    countryFrom: string
    countryTo: string
    countries: string
    currencyFrom: string
    currencyTo: string
    currencies: string
    amount?: number
    amountUsd?: number
  }
  alternativeToNoResults?: string
}

export function mapCorridor(corridor: CorridorParams): CorridorProperties {
  return {
    corridor: {
      countryFrom: corridor.countryFrom.iso,
      countryTo: corridor.countryTo.iso,
      currencyFrom: corridor.currencyFrom.iso,
      currencyTo: corridor.currencyTo.iso,
      countries: `${corridor.countryFrom.iso}-${corridor.countryTo.iso}`,
      currencies: `${corridor.currencyFrom.iso}-${corridor.currencyTo.iso}`,
      amount: corridor.amount ?? corridor.defaultAmount,
      amountUsd: corridor.amountUsd,
    },
    alternativeToNoResults: corridor.alternativeToNoResults,
  }
}
